'use strict';
// import Splide from "@splidejs/splide";

// window.Splide = Splide;

document.addEventListener('DOMContentLoaded', () => {
  // btn to top
  const btnToTop = document.querySelector('.button-top');
  window.addEventListener('scroll', () => {
    if(window.scrollY > 300) {
      btnToTop.classList.add('button-top--active');
    } else {
      btnToTop.classList.remove('button-top--active');
    }
  });

  btnToTop.addEventListener('click', () => {
    document.body.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  });
});